import { createSlice } from "@reduxjs/toolkit";

const generalSlice = createSlice({
  name: "general",
  initialState: {
    loginLoaded: false,
    isDrawerMenuOpen: false,
    currentPage: "dashboard",
    adminCurrentTab: "employees",
    superAdminCurrentTab: "admin-roles",
    approverCurrentTab: "tr-local",
    spectatorCurrentTab: "tr-local",
    trCurrentTab: "tr-local",
    ebullCurrentTab: null, // This should be id
    dashboardCurrentTab: "dashboard",
    ouberReqTab: "my-requests",
    ouberAdminCalTab: "calendar",
    ouberUserCalTab: "calendar",
    bulletins: [],
    dataView: "table",
  },
  reducers: {
    showPopup: (state, action) => {
      const popupKey = action.payload;
      state[popupKey] = true;
    },
    hidePopup: (state, action) => {
      const popupKey = action.payload;
      state[popupKey] = false;
    },
    toggleMenuDrawer: (state) => {
      state.isDrawerMenuOpen = !state.isDrawerMenuOpen;
    },
    openMenuDrawer: (state) => {
      state.isDrawerMenuOpen = true;
    },
    closeMenuDrawer: (state) => {
      state.isDrawerMenuOpen = false;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setAdminTab: (state, action) => {
      state.adminCurrentTab = action.payload;
    },
    setTrTab: (state, action) => {
      state.trCurrentTab = action.payload;
    },
    setApproverTab: (state, action) => {
      state.approverCurrentTab = action.payload;
    },
    setEbullTab: (state, action) => {
      state.ebullCurrentTab = action.payload;
    },
    setSpectatorTab: (state, action) => {
      state.spectatorCurrentTab = action.payload;
    },
    setDashTab: (state, action) => {
      state.dashboardCurrentTab = action.payload;
    },
    setOuberReqTab: (state, action) => {
      state.ouberReqTab = action.payload;
    },
    setOuberAdminTab: (state, action) => {
      state.ouberAdminCalTab = action.payload;
    },
    setOuberUserTab: (state, action) => {
      state.ouberUserCalTab = action.payload;
    },
    setSuperAdminTab: (state, action) => {
      state.superAdminCurrentTab = action.payload;
    },
    setLoginLoaded: (state, action) => {
      state.loginLoaded = action.payload;
    },
    setBulletins: (state, action) => {
      state.bulletins = action.payload;
    },

    setViewMode: (state, action) => {
      state.dataView = action.payload === "card" ? "card" : "table";
    },
    toggleViewMode: (state) => {
      state.dataView = state.dataView === "table" ? "card" : "table";
    },
  },
  devTools: true,
});

export const {
  showPopup,
  hidePopup,
  toggleMenuDrawer,
  openMenuDrawer,
  closeMenuDrawer,
  setPage,
  setAdminTab,
  setTrTab,
  setApproverTab,
  setEbullTab,
  setSpectatorTab,
  setDashTab,
  setOuberReqTab,
  setOuberAdminTab,
  setOuberUserTab,
  setSuperAdminTab,
  setLoginLoaded,
  setBulletins,
  setViewMode,
  toggleViewMode,
} = generalSlice.actions;
export default generalSlice.reducer;
